module.exports = __webpack_public_path__ + "img/Coccomyxa_subellipsoidea.15e803b5.jpg";